'use client'
import {useEffect, useState} from "react"

export default function ThemeSwitch() {
	const [theme, setTheme] = useState<string>("light")
	useEffect(() => {
		const currentTheme = document.documentElement.getAttribute("data-bs-theme") || "light"
		setTheme(currentTheme)
	}, [])

	const toggleTheme = () => {
		const newTheme = theme === "light" ? "dark" : "light";
		setTheme(newTheme);
		localStorage.setItem("theme", newTheme)
		document.documentElement.setAttribute("data-bs-theme", newTheme);
	}

	return (
		<div
			className="dark-light-switcher d-flex justify-content-center align-items-center icon-shape icon-md border bg-white rounded-3 ms-3 me-md-3 me-0"
			onClick={toggleTheme}
			style={{ cursor: "pointer" }}
		>
			{/* Toggle icon based on theme */}
			<i className={`bi theme-icon ${theme === "light" ?  "bi-moon-stars-fill" :"bi-sun-fill"}`} />
		</div>
	)
}
